const detalhes = [
  {
    icon: 'ri-contrast-drop-2-line',
    titulo: 'Persianas Blackout',
    descricao:
      'Possibilidade de incluir persianas nos perfis para total privacidade nas salas. São acionadas através de um botão externo (item opcional).',
    image:
      'https://www.gabbinetto.com.br/img/produtos/divisoria-piso-teto-vidro-duplo/especificacoes/persianas.jpg',
    alt: 'Persianas blackout integradas entre os vidros de uma divisória corporativa — Gabbinetto',
  },
  {
    icon: 'ri-toggle-line',
    titulo: 'Interruptores integrados',
    descricao:
      'Possibilidade de incluir interruptores e todo o cabeamento de forma embutida dentro dos batentes (item opcional).',
    image:
      'https://www.gabbinetto.com.br/img/produtos/divisoria-piso-teto-vidro-duplo/especificacoes/interruptor.jpg',
    alt: 'Interruptor e cabeamento embutido na estrutura de uma divisória de vidro — Gabbinetto',
  },
  {
    icon: 'ri-door-closed-line',
    titulo: 'Vedação de porta',
    descricao:
      'Sistema opcional para vedação de porta, que protege o ambiente contra poeira e ruídos externos. O acessório é acionado automaticamente no momento que a porta é fechada.',
    image:
      'https://www.gabbinetto.com.br/img/produtos/divisoria-piso-teto-vidro-duplo/especificacoes/vedacao-porta.jpg',
    alt: 'Sistema de vedação de porta em divisória corporativa piso-teto — Gabbinetto',
  },
];

export default function DetalhesPremium() {
  return (
    <section className="bg-white">
      <div className="max-w-[1200px] mx-auto px-5 md:px-8 py-20 md:py-28">
        <div className="max-w-2xl mb-14">
          <p className="text-[12px] md:text-[13px] font-semibold tracking-[0.28em] uppercase text-primary-500 mb-4">
            Detalhes premium
          </p>
          <h2 className="text-foreground-950 text-[28px] md:text-[38px] font-semibold tracking-tight leading-tight">
            É nos detalhes que um projeto corporativo se diferencia.
          </h2>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
          {detalhes.map((d) => (
            <div key={d.titulo} className="group flex flex-col">
              <div className="img-zoom rounded-2xl overflow-hidden bg-background-100 aspect-[4/3] mb-5">
                <img
                  src={d.image}
                  alt={d.alt}
                  loading="lazy"
                  decoding="async"
                  className="w-full h-full object-cover object-center"
                />
              </div>
              <span className="w-10 h-10 flex items-center justify-center rounded-xl bg-background-100 text-foreground-700 mb-4 group-hover:bg-primary-50 group-hover:text-primary-600 transition-colors">
                <i className={`${d.icon} text-xl`}></i>
              </span>
              <h3 className="text-foreground-950 font-semibold text-[16px] mb-2">{d.titulo}</h3>
              <p className="text-foreground-500 text-[13px] leading-relaxed font-light">
                {d.descricao}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}